module.exports = __webpack_public_path__ + "static/media/style-1.e0a4e647.svg";